import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import EDMenuButton from '../../../../../../../../../BaseComponents/Buttons/MenuButton/EDMenuButton';
import MenuButtonItem from '../../../../../../../../../BaseComponents/Buttons/MenuButton/EDMenuButtonItem';
import { EDInputGroup } from '../../../../../../../../../BaseComponents/InputGroup/EDInputGroup';
import { useIsTouchDevice } from '../../../../../../../../../Components/BreakpointContext/BreakpointContextUtils';
import { FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All } from '../../../../Queries/_QueryTypes/FakturaDelQuery';
import KonteringLabel from '../../KonteringLabel';
import { EDControlledExpansionPanel as EDExpansionPanel } from '../../../../../../../../../BaseComponents/Accordion/EDExpansionPanel';

interface IProps {
  beslutsAttestant:
    | FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All
    | null
    | undefined;
  fakturaBelopp: number;
  kodstrang: string;
  kodstrangBenamningar: string[];
  beloppExklMoms?: number | null;
  beloppInklMoms?: number | null;
  radtyp?: number | null | undefined;
}

const useStyles = makeStyles()((theme: Theme) => ({
  expandableContentContainer: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderRadius: 0,
    padding: 0,
    position: 'relative',
    boxSizing: 'border-box',
    [theme.breakpoints.up('sm')]: {
      width: '100%',
    },
    '&:first-of-type': {
      marginTop: theme.spacing(1),
    },
    '&:last-child, :only-child': {
      borderBottom: 0,
    },
  },
  expandableInnerContainer: {
    width: '100%',
    backgroundColor: 'transparent',
    '& [class*="MuiAccordion-root"]': {
      '&[class*="MuiAccordion-rounded"]': {
        '&[class*="MuiPaper-rounded"]': {
          '&[class*="Mui-expanded"]': {
            boxShadow: 'none',
            '&:first-of-type': {
              marginTop: 0,
            },
            '&:last-child': {
              marginBottom: 0,
            },
            '& [class*="MuiAccordionSummary-root"], & [class*="MuiAccordionDetails-root"]':
              {
                backgroundColor: 'transparent',
              },
          },
        },
      },
    },
  },
  expansionPanelRoot: {
    backgroundColor: 'transparent',
  },
  content: {
    backgroundColor: theme.palette.background.default,
  },
  summaryContent: {
    width: `calc(100% - ${theme.spacing(9.5)})`,
  },

  functionMenu: {
    display: 'none',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 1,
    height: '100%',
    [theme.breakpoints.up('md')]: {
      right: theme.spacing(1),
    },
  },
  showFunctionMenu: {
    display: 'flex',
  },
  iconWrapper: {
    marginRight: theme.spacing(1.5),
    [theme.breakpoints.up('md')]: {
      marginRight: theme.spacing(3.5),
    },
  },
  loadingContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    minHeight: '80px',
    position: 'relative',
    width: '100%',
  },
}));

const SkeletonKontering: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { classes, cx } = useStyles();
  const isTouch = useIsTouchDevice();

  return (
    <EDInputGroup>
      <div className={classes.expandableContentContainer}>
        <div className={classes.expandableInnerContainer}>
          <EDExpansionPanel
            key="kontering"
            disabled={true}
            classes={{
              ['root']: classes.expansionPanelRoot,
              content: classes.summaryContent,
              ['detailsRoot']: classes.content,
              ['expandIconWrapper']: classes.iconWrapper,
            }}
            expanded={false}
            onChange={() => {}}
            label={
              <>
                <KonteringLabel
                  kodstrang={props.kodstrang}
                  belopp={props.fakturaBelopp}
                  kodstrangBenamningar={props.kodstrangBenamningar}
                  konteringsforslagSaknas={props.kodstrangBenamningar.every(
                    str => str === ''
                  )}
                  attestTyp={null}
                  infoMissingMessage="Kontering saknas"
                  onBeslutsattestantChanged={() => {}}
                  beslutsAttestant={props.beslutsAttestant}
                  beslutsattestanter={[]}
                  showTillaggsInfo={false}
                  showPeriodIcon={false}
                  statusIcon={undefined}
                  beloppExklMoms={props.beloppExklMoms}
                  beloppInklMoms={props.beloppInklMoms}
                  radtyp={props.radtyp}
                />
              </>
            }
          ></EDExpansionPanel>
        </div>
        <span
          className={cx([
            classes.functionMenu,
            isTouch ? classes.showFunctionMenu : '',
          ])}
        >
          <EDMenuButton
            disabled
            icon="more_vert"
            tooltip="Öppna alternativ"
            padding={0}
            transparentBackground
          >
            <MenuButtonItem></MenuButtonItem>
          </EDMenuButton>
        </span>
      </div>
    </EDInputGroup>
  );
};

export default SkeletonKontering;
